import { AxiosError } from "axios";

import { api } from "@/lib/axios";

interface updateAcademyTrainingModuleData {
	name: string;
	training_id: string;
}

export async function updateAcademyTrainingModule(
	id: string,
	data: updateAcademyTrainingModuleData,
): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.put(`/module/update/${id}`, data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
